export default class ScouteeFormFile {
  constructor() {
    document.addEventListener('DOMContentLoaded', this.scouteeFormFile);
  }

  scouteeFormFile() {
    const ScouteeFormFileTargets = Array.from(document.querySelectorAll('.js-scoutee-form-file'));
    ScouteeFormFileTargets.forEach((el) => {
      new Vue({
        el,
        name: 'ScouteeFormFile',
        data() {
          const defaultFilename = '添付ファイル';
          return {
            defaultFilename,
            filename: defaultFilename,
          };
        },
        computed: {
          showRemove() {
            return this.filename !== this.defaultFilename;
          },
        },
        methods: {
          handleChange(e) {
            const file = e.target.files[0];
            if (file) {
              this.filename = file.name;
            } else {
              this.filename = this.defaultFilename;
            }
          },
          handleRemove() {
            this.filename = this.defaultFilename;
            this.$refs.input.value = '';
          },
        },
      });
    });
  }
}
